import AHRIRelatedProductReducer from "@crescentParts/Store/Data/AHRIRelatedProduct/AHRIRelatedProductReducer";
import AHRISystemDataReducer from "@crescentParts/Store/Data/AHRISystemData/AHRISystemDataReducer";
import AHRIProductReducer from "@crescentParts/Store/Data/AHRISystemProducts/AHRIProductReducer";
import AHRISystemToolConfigCategoryReducer from "@crescentParts/Store/Data/AHRISystemToolCategory/AHRISystemToolConfigCategoryReducer";
import AHRISystemToolConfigReducer from "@crescentParts/Store/Data/AHRISystemToolConfig/AHRISystemToolConfigReducer";
import AHRISystemToolPaginationReducer from "@crescentParts/Store/Data/AHRISystemToolPagination/AHRISystemToolPaginationReducer";
import CustomOnePageCheckoutDeliveryMethodReducer from "@crescentParts/Store/Data/CustomOnePageCheckoutDeliveryMethod/CustomOnePageCheckoutDeliveryMethodReducer";
import RelatedProductModalReducer from "@crescentParts/Store/Data/CustomRelatedProductsOnCart/RelatedProductModalReducer";
import OnePageCheckoutCustomNotesReducer from "@crescentParts/Store/Data/OnePageCheckoutCustomNotes/OnePageCheckoutCustomNotesReducer";
import PageHistoryReducer from "@crescentParts/Store/Data/PageHistory/PageHistoryReducer";
import RequestConvertQuoteReducer from "@crescentParts/Store/Data/RequestConvertQuote/RequestConvertQuoteReducer";
import TrainingEnquiryReducer from "@crescentParts/Store/Data/TrainingEnquiry/TrainingEnquiryReducer";
import WarehouseDataReducer from "@crescentParts/Store/Data/WarehouseData/WarehouseDataReducer";
import { combineReducers } from "redux";
import CustomerPricingReducer from "@crescentParts/Store/Data/CustomerPricing/CustomerPricingReducer";

const customReducers = {
    AHRIProduct: AHRIProductReducer,
    AHRISystemToolConfig: AHRISystemToolConfigReducer,
    AHRISystemToolPagination: AHRISystemToolPaginationReducer,
    AHRISystemToolConfigCategory: AHRISystemToolConfigCategoryReducer,
    PageHistory: PageHistoryReducer,
    OnePageCheckoutCustomNotes: OnePageCheckoutCustomNotesReducer,
    AHRISystemData: AHRISystemDataReducer,
    RequestConvertQuote: RequestConvertQuoteReducer,
    TrainingEnquiry: TrainingEnquiryReducer,
    CustomOnePageCheckoutDeliveryMethodError: CustomOnePageCheckoutDeliveryMethodReducer,
    warehouseData: WarehouseDataReducer,
    relatedProductsCustomModal: RelatedProductModalReducer,
    ahriRelatedProductState: AHRIRelatedProductReducer,
    customerPricingData: CustomerPricingReducer
};

export type CustomDataReducers = typeof customReducers;

const customDataReducer = combineReducers(customReducers as any);

export default customDataReducer;
